import { render, staticRenderFns } from "./vector-input.vue?vue&type=template&id=1682dbec&scoped=true&"
import script from "./vector-input.vue?vue&type=script&lang=ts&"
export * from "./vector-input.vue?vue&type=script&lang=ts&"
import style0 from "./vector-input.vue?vue&type=style&index=0&id=1682dbec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1682dbec",
  null
  
)

export default component.exports